<template>
    <mvtDialog v-if="componentMounted" ref="dialog" @hidden="hide" v-ga:dialog :class="componentName" :comp="componentName">
        <component v-slot:default v-if="componentTemplate" :options="componentOpt" :is="componentTemplate" :comp="componentName"/>
    </mvtDialog>
    <div v-if="componentMounted" @click="hideMessage" class="mvt-dialogcenter-tip p-x-3 p-y-2 inline corner active" :class="[isNewStyle ? 'lighter' : 'default', {show: showTip}]">
        <div class="flex center middle">
            <i v-if="!isNewStyle" class="f2 icon-check-circle-outside text-brand"></i>
            <div class="f6" v-html="message"></div>
        </div>
    </div>
</template>

<script src="./mvt-dialogcenter.js"></script>

<style lang="scss">
@use "./mvt-dialogcenter.scss" as *;
</style>